// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iqR4","label":"styles_label__190qX"};